/**
 * ps_checkout_block.js
 * Le checkout est le BLOC WooCommerce (`.wc-block-checkout`) — nécessaire pour le Local
 * Pickup (magasins de retrait). Le bloc fait sa propre grille et IGNORE les hooks PHP
 * classiques (`woocommerce_before_checkout_form`, `…after_order_review`), donc nos encarts
 * thème (« Retour au panier », « Besoin d'aide ? ») ne sont pas rendus par WooCommerce.
 *
 * On les imprime côté serveur dans des <template> (cf. pdw_checkout_block_extras) et on les
 * injecte ici :
 *   - « Retour au panier » → en tête de la colonne principale (.wc-block-checkout__main)
 *   - « Besoin d'aide ? »  → dans la colonne résumé (.wc-block-checkout__sidebar)
 *
 * ⚠️ Le bloc est rendu/réconcilié par React → on garde un MutationObserver actif et une
 *    ré-injection IDEMPOTENTE (guard sur la présence) pour survivre aux re-renders.
 */
(function () {
	function cloneTpl( id ) {
		var tpl = document.getElementById( id );
		return tpl && tpl.content ? tpl.content.cloneNode( true ) : null;
	}

	function inject() {
		var checkout = document.querySelector( '.wc-block-checkout' );
		if ( ! checkout ) {
			return false;
		}

		// Besoin d'aide → sidebar (après le résumé)
		var sidebar = document.querySelector( '.wc-block-checkout__sidebar' );
		if ( sidebar && ! sidebar.querySelector( '.pdw-checkout-help' ) ) {
			var help = cloneTpl( 'pdw-checkout-help-tpl' );
			if ( help ) {
				sidebar.appendChild( help );
			}
		}

		// Retour au panier → en tête de la colonne principale
		var main = document.querySelector( '.wc-block-checkout__main' );
		if ( main && ! main.querySelector( '.pdw-checkout-back' ) ) {
			var back = cloneTpl( 'pdw-checkout-back-tpl' );
			if ( back ) {
				main.insertBefore( back, main.firstChild );
			}
		}

		return !! ( sidebar && main );
	}

	function start() {
		if ( ! document.querySelector( '.wc-block-checkout' ) ) {
			return;
		}
		inject();
		// Le bloc s'hydrate / se re-render en continu → observer + ré-injection idempotente.
		var obs = new MutationObserver( function () {
			inject();
		} );
		obs.observe( document.body, { childList: true, subtree: true } );
	}

	if ( document.readyState !== 'loading' ) {
		start();
	} else {
		document.addEventListener( 'DOMContentLoaded', start );
	}
})();
